import React, { useEffect, useState } from "react";
import formatTimestampForNotification from "../lib/formatTimestampForNotification";
import { useNavigate } from "react-router-dom";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { db } from "../FirebaseConfig";
import { doc, updateDoc } from "firebase/firestore";
import useSocketStore from "../StatesStore/Socket";

function NotificationItem2({
  notification,
  message,
  route,
  firstUserData,
  user,
  group,
}) {
  const navigate = useNavigate();
  const [isSeen, setIsSeen] = useState(notification.seen);
  const [isRecipientOnline, setIsRecipientOnline] = useState(false);
  const socket = useSocketStore((state) => state.socket);

  useEffect(() => {
    if (firstUserData?.userId && socket) {
      // Listen for status updates for the specific firstUser
      const handleUserStatus = ({ userId, status }) => {
        if (userId === firstUserData?.userId) {
          setIsRecipientOnline(status === "online");
        }
      };
      console.log("firstUserData?.userId", firstUserData?.userId);

      // Register the listener
      socket.on("user status", handleUserStatus);

      // Request initial status of the firstUser
      socket.emit("get user status", firstUserData?.userId);
    }
  }, [firstUserData?.userId]);

  const handleNavigate = async () => {
    try {
      // Navigate to the dynamic route
      navigate(route);

      // Update the 'seen' attribute to true in Firestore
      if (!isSeen) {
        setIsSeen(true);
        const notificationRef = doc(
          db,
          "users",
          user?.uid,
          "notifications",
          notification.notificationId
        );
        await updateDoc(notificationRef, { seen: true });
      }
    } catch (error) {
      console.error("Error updating notification: ", error);
    }
  };

  return (
    <li
      onClick={handleNavigate}
      className="border-bottom"
      style={{
        padding: "0.625rem 1rem",
        cursor: "pointer",
        backgroundColor: !isSeen ? "#EFF6FF" : "transparent",
      }}
    >
      <div
        className={`d-flex my-0`}
        style={{ display: "inline-flex", gap: "12px", cursor: "pointer" }}
      >
        <div
          style={{ height: "50px", width: "50px" }}
          className={`avatar text-center d-inline-block ${
            isRecipientOnline ? "status-online" : " "
          }`}
        >
          <ProfilePicture userData={firstUserData} />
        </div>
        <div
          className={`w-100 rounded-2 p-0 d-flex align-items-center justify-content-center `}
        >
          <div
            className="w-100 d-flex gap-2 flex-column justify-content-between p-0"
            style={{ fontFamily: "Inter", color: "#676A79", fontWeight: 600 }}
          >
            <div className="d-flex flex-grow-1">
              <p
                className={`small mb-0  ${!group ? "d-flex flex-column" : ""}`}
              >
                <span
                  style={{
                    fontFamily: "Inter",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  {firstUserData?.userName}
                </span>
                <span style={{ fontSize: "15px" }}>{message}</span>
              </p>
            </div>
            {/* Comment Box */}
            {/* <div style={{ fontSize: "13px", borderLeft:'2px solid #0085FF', padding:'8px 13px' }} >
              This is a great idea! I will steal it, say it's mine, and give
              credit to myself of course... wait... I already did!
            </div> */}
            {/* Accept or Decline Buttons */}
            {/* <div className="d-flex gap-2">
              <div className="btn btn-primary btn-sm rounded-2">Accept</div>
              <div className="btn border btn-sm rounded-2" style={{color:'#696F8C'}}>Deny</div>
            </div> */}
            <div className="small mb-1" style={{ fontSize: "12px" }}>
              {formatTimestampForNotification(notification.timestamp)}
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

export default NotificationItem2;
